// init API client interceptors
import '@api/interceptors.api';

import { realEstatesApi } from './apartments.api';
import { contractApi } from './contracts.api';
import { incidentApi } from './incidents.api';
import { loginApi, signupApi } from './login.api';
import { measurementsApi } from './measurement.api';
import { noticesApi } from './notices.api';
import { parkingApi } from './parking.api';
import { residentsApi } from './residents.api';
import { saunaApi } from './sauna.api';
import { userApi } from './user.api';

export const api = {
  residents: residentsApi,
  contracts: contractApi,
  signup: signupApi,
  login: loginApi,
  incidents: incidentApi,
  measurements: measurementsApi,
  sauna: saunaApi,
  apartments: realEstatesApi,
  user: userApi,
  parking: parkingApi,
  notices: noticesApi,
};
